var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateTrackOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.61 3.552v.002l-4.683 27.32-.002.01a.97.97 0 0 1-.142.313c-.1.141-.274.305-.673.305a.966.966 0 0 1-.462-.107.616.616 0 0 1-.093-.06l-.005-.004-.015-.014-10.143-9.619-.064-.061-.078-.044-4.962-2.859-.074-.043-.082-.025-6.351-1.93-.008-.003a1.353 1.353 0 0 1-.326-.19c-.173-.14-.286-.307-.286-.54 0-.093.06-.228.282-.394a1.837 1.837 0 0 1 .375-.213l.02-.009.023-.008.026-.012 26.63-12.09.015-.006a4.472 4.472 0 0 1 .388-.134c.26-.079.526-.135.708-.135h.002c.01 0 .021 0 .03.002a3.731 3.731 0 0 1-.043.504l-.006.036-.001.008z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#k6eajpn2sa)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.197 22.08 3.755 3.745-3.778 3.746.023-7.49z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#ofxe0iqhob)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.32 27.895-.19 1.334m.19-1.334c.16.532.282.948.348 1.186l-.537.148m.189-1.334.812-5.748.034-.237.164-.173L30.232 9.153l-15.44 10.56a2061.395 2061.395 0 0 1 1.202 3.862c.48 1.549.986 3.192 1.326 4.32zm-.19 1.334-.183.051.184-.05",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#sug4ps6xec)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.238 26.687 7.97 31.955m9.355-.512-5.268 5.268m2.634-7.39-2.905 2.906",
    stroke: "url(#457x0m4hpd)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k6eajpn2sa",
    x1: 28.672,
    y1: 48.324,
    x2: -1.908,
    y2: 36.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ofxe0iqhob",
    x1: 21.374,
    y1: 36.075,
    x2: 15.727,
    y2: 34.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sug4ps6xec",
    x1: 26.896,
    y1: 42.985,
    x2: 8.028,
    y2: 37.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "457x0m4hpd",
    x1: 14.912,
    y1: 42.081,
    x2: 5.209,
    y2: 38.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateTrackOrderIcon);
export default __webpack_public_path__ + "static/media/corporateTrackOrderIcon.7822cedd1e6797e9cedacdbca33792a8.svg";
export { ForwardRef as ReactComponent };